<script setup lang="ts">
  import AplosFileUpload from '@/components/FileManager/components/AplosFileUpload.vue'
  import { AplosFile } from '@/components/FileManager/models/AplosFile'
  import { ref } from 'vue'

  interface IUploadNewDatasetProps {
    hideUploadButton?: boolean
  }

  const props = defineProps<IUploadNewDatasetProps>()

  const fileUploadRef = ref<any>(null)

  // emit to notify parent when an input file has been set
  const emit = defineEmits<{
    (e: 'input-file-set', payload: AplosFile): void
    (e: 'upload-clicked', event?: Event): void
    (e: 'files-selected', files?: File[]): void,
    (e: 'upload-complete'): void
  }>()

  const onUploadClicked = (event?: Event): void => {
    emit('upload-clicked', event)
  }

  const onFilesSelected = (files?: File[]): void => {
    emit('files-selected', files)
  }

  const onUploadComplete = (): void => {
    emit('upload-complete')
  }

  // Set data when a user uploads a new dataset
  // this should contain column header data
  const handleUpdateFileRef = (payload: AplosFile) => {
    // notify parent component that a file has been set
    emit('input-file-set', payload)
  }

  const startUpload = async (event?: Event) => {
    if (fileUploadRef.value?.handleUploads) {
      await fileUploadRef.value.handleUploads(event)
    }
  }

  const resetUpload = (): void => {
    fileUploadRef.value?.resetUpload?.()
  }

  defineExpose({ startUpload, resetUpload })
</script>

<template>
  <!-- Dynamic area: hook up Upload New Dataset for now -->
  <div class="w-full">
    <!-- listen for the FileUpload emitted payload -->
    <AplosFileUpload
      ref="fileUploadRef"
      :auto-upload="false"
      :multiple="false"
      @upload-clicked="onUploadClicked"
      @updateFileRef="handleUpdateFileRef"
      @files-selected="onFilesSelected"
      @upload-complete="onUploadComplete"
      :hide-upload-button="props.hideUploadButton"
    >
      <template #uploadButton="slotProps">
        <slot name="uploadButton" v-bind="slotProps"></slot>
      </template>
    </AplosFileUpload>
  </div>
</template>

<style scoped></style>
